import { Snackbar, Alert, Stack } from '@mui/material'
import { useToast } from './useToast'

export function Toaster() {
  const toasts = useToast((s) => s.toasts)
  const remove = useToast((s) => s.remove)
  return (
    <Stack spacing={1} sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: 1400 }}>
      {toasts.map((t) => (
        <Snackbar key={t.id} open onClose={() => remove(t.id)}>
          <Alert severity={t.level} onClose={() => remove(t.id)} sx={{ width: 360 }}>
            {t.message}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  )
}
